import React, { lazy } from 'react';
import { connect } from 'react-redux';
import CashAccountAccountProfileMobile from '../../components/MyAccount/CashAccountProfile/CashAccountAccountProfileMobile'
import { getSafe } from '@/helpers/global';
import '../../assets/styles/pages/my-account/my-account-mobile.scss'
import { Icons } from '@/configurations/app-configs/app-icons'
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';

class MyAccountMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  openPage(type) {
    if(type === 0) {
      mobileSubLayoutAction.openPortfolio();
    } else {
      mobileSubLayoutAction.openTransactionHistory();
    }
  }

  render() {
    const { language } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <main style={{overflowY:'scroll'}}>
          <CashAccountAccountProfileMobile />
          <nav>
            <div className="pointer" onClick={() => this.openPage(0)}>
              <span>{getSafe(() => language.portfolio_title)}</span>
              <span className="list-enter-icon"><Icons.RightArrow /></span>
            </div>
            <div className="pointer" onClick={() => this.openPage(1)}>
              <span>
                {getSafe(() => language.transaction_history_title)}
              </span>
              <span className="list-enter-icon"><Icons.RightArrow /></span>
            </div>
          </nav>
        </main>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language
  }),
  dispatch => ({

  })
)(MyAccountMobile)
